"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeProcesVerbalSheet = void 0;
const index_1 = require("../../index");
const makeProcesVerbalSheet = () => {
    return [
        {
            '@type': 'grid',
            'key': '0f4f5f29-94fd-4f39-b238-a2817d95cfa3',
            columns: 1,
            children: [
                {
                    '@type': 'card',
                    key: 'ff4cc48c-249c-43c9-b4a4-47605d89d736',
                    title: 'Procés verbal',
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: 'd5a34e77-632c-4b89-805c-5e5d1852d35e',
                            columns: 1,
                            children: [...index_1.template.procesVerbalSheet],
                        },
                    ],
                },
            ],
        },
    ];
};
exports.makeProcesVerbalSheet = makeProcesVerbalSheet;
``;
